import { parseHighlightValueDependingOnDecimals } from './utils/animation'
import { initializeBarDiagram } from './diagram/bar-diagram'
import { initializePieDiagram } from './diagram/pie-diagram'

function init () {
  initializeDiagram()
}

function initializeDiagram () {
  const diagrams = document.querySelectorAll('.diagram')
  diagrams.forEach((diagram) => {
    const diagramType = diagram.dataset.type
    const highlight = diagram.querySelector('.diagram-highlight-value')
    let { highlightValue, decimals } = parseHighlightValueDependingOnDecimals(highlight)
    const locale = diagram.dataset.lang

    const observer = new IntersectionObserver((entries, obs) => {
      const entry = entries[0]
      if (entry.isIntersecting) {
        if (diagramType === 'pie' || diagramType === 'donut') {
          initializePieDiagram(diagram, diagramType, highlight, highlightValue, decimals, locale)
        } else {
          initializeBarDiagram(diagram, diagramType, highlight, highlightValue, decimals, locale)
        }
        obs.disconnect()
      }
    }, { threshold: 0.01 })

    observer.observe(diagram)
  })
}

export default {
  init,
}
